import { createAppSettingsContext } from '@britishcouncil/react-common';
import { UserManagerSettings } from 'oidc-client-ts';

export interface AppSettings {
  userManagerSettings: UserManagerSettings;
  appVersion: string;
  sentryUri: string | null;
  environment: string;
  planExamsUrl: string;
}

export const DEFAULT_APP_SETTINGS: AppSettings = {
  userManagerSettings: {
    authority: 'https://localhost:5000',
    redirect_uri: 'http://localhost:3000/callback',
    client_id: 'event-planner.app',
    response_type: 'code',
    scope:
      'openid profile email eam.auth eam.internal.api is_api.user_permissions offline_access ors2-modernisation.planning.api ors2-modernisation.reports.planning.api',
  },
  appVersion: '0.0.0-local',
  sentryUri: null,
  environment: 'local',
  planExamsUrl: 'https://host.docker.internal:3500',
};

export const { AppSettingsContext, useAppSettings } = createAppSettingsContext<AppSettings>();
